import { CoordinateSystem, type PointRequest, SinglePointCoordinate } from "@mm/api.meteomatics.com";
import type { Feature, GeoJsonProperties, LineString } from "geojson";
import { type DateTime, Duration } from "luxon";

export function extractLineStringCoordinatesAndRanges(batch: Feature<LineString, GeoJsonProperties>[]): {
  coordinates: SinglePointCoordinate<CoordinateSystem.WGS84>[];
  indexRanges: { startIndex: number; endIndex: number }[];
} {
  const lineStringCoordinates: SinglePointCoordinate<CoordinateSystem.WGS84>[] = [];
  const lineStringIndexRanges: { startIndex: number; endIndex: number }[] = [];

  for (const feature of batch) {
    const coordinates = feature.geometry.coordinates.map(
      ([lon, lat]) => new SinglePointCoordinate<CoordinateSystem.WGS84>(lat, lon, CoordinateSystem.WGS84),
    );

    const startIndex = lineStringCoordinates.length;
    lineStringCoordinates.push(...coordinates);
    const endIndex = lineStringCoordinates.length - 1;

    lineStringIndexRanges.push({ startIndex, endIndex });
  }

  return { coordinates: lineStringCoordinates, indexRanges: lineStringIndexRanges };
}

export function createRequestLineStringCoordinates(
  coordinates: SinglePointCoordinate<CoordinateSystem.WGS84>[],
  parameter: string,
  model: string,
  datetime: DateTime,
): PointRequest<CoordinateSystem.WGS84> {
  return {
    coordinates: coordinates,
    startDatetime: datetime,
    duration: Duration.fromISO("PT0H"),
    temporalResolution: Duration.fromISO("PT1H"),
    width: 0,
    height: 0,
    parameters: [parameter],
    model,
    boundingBoxLimit: null,
  };
}
